import {Line} from '../Line';
import {Curve} from './Curve';
import {Axis} from './Axis';
import {Text} from './Text';
import {Selectable} from '../Selectable';
import {IColorChangeable, ICloneable} from '../../Interfaces';

declare const THREE: any;

export class Angle extends Selectable implements IColorChangeable, ICloneable {

  private startPoint;
  private endPoint;
  private color;

  constructor() {
    super();
    this.add(new Line());
    this.add(new Curve(50));
    this.add(new Axis(150));
    const label = new Text({width: 50, height: 25}, {width: 128, height: 64, fontSize: 30});
    this.add(label);
    this.startPoint = new THREE.Vector3();
    this.endPoint = new THREE.Vector3();
    this.color = new THREE.Color(0x000000);
  }

  update(startPoint, endPoint) {
    this.startPoint.copy(startPoint);
    this.endPoint.copy(endPoint);
    this.getObjectByName<Line>(Line.Name).update(startPoint, endPoint);
    this.getObjectByName<Curve>(Curve.Name).update(startPoint, endPoint);
    this.getObjectByName<Text>(Text.Name).update(startPoint, endPoint);
  }

  getBoundingBoxObjects(): Array<any> {
    return [this.getObjectByName(Line.Name), this.getObjectByName(Axis.Name)];
  }

  setColor(color): void {
    this.color.copy(color);
    this.getObjectByName(Line.Name).setColor(color);
    this.getObjectByName(Curve.Name).setColor(color);
  }

  duplicate(): Angle {
    const angle = new Angle();
    angle.update(this.startPoint, this.endPoint);
    angle.setColor(this.color);
    return angle;
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    return {
      type: "Angle",
      position: pos,
      startPoint: { x: this.startPoint.x, y: this.startPoint.y, z: this.startPoint.z },
      endPoint: { x: this.endPoint.x, y: this.endPoint.y, z: this.endPoint.z },
      color: this.color.getHex()
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Angle/index.ts